/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/phone/qaPhoneSelectAll.ts
 * FILE_ID: JOBHUB-QA-PHONE-SELECT-ALL-001
 * PURPOSE: Which ids the title square selects for the sheet that is open.
 */
export function phoneVisibleSelection(input: {
  areaSheetOpen: boolean
  allChecklists: boolean
  areaIds: readonly string[]
  checklistIds: readonly string[]
  itemIds: readonly string[]
}): { scope: 'areas' | 'checklists' | 'checks'; ids: string[] } {
  if (input.areaSheetOpen) return { scope: 'areas', ids: [...input.areaIds] }
  if (input.allChecklists) return { scope: 'checklists', ids: [...input.checklistIds] }
  return { scope: 'checks', ids: [...input.itemIds] }
}
